import styled from 'styled-components';

export const CanvasWrapper = styled.div`
    padding: 5px;
    position: relative;
`;

// NOTE: not sure if these styles are really doing anything
export const List = styled.ul`
    padding: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
    z-index: 0;
`;

export const DropZone = styled.div`
    z-index: 0;
    height: 585px;
    background-color: #ededef;
    position: relative;
`;

export const Div = styled.div`
    padding: 10px;
    margin: 10px auto;
`;

export const DropZoneText = styled.p`
    font-size: 15px;
    color: 'black';
    font-weight: bold;
    background: white;
    width: 120px;
    height: 20px;
    left: calc(50% - 60px);
    top: calc(50% - 10px);
    text-align: center;
    position: absolute;
`;

export const EmptyStateDiv = styled.div`
    text-align: center;
`;

export const EmptyStateText = styled.div`
    text-align: center;
    margin-top: 26px;
    color: ${({ theme }) => theme.colors.neutral900};
`;

interface IDropZoneBar {
    isVisible: boolean;
}

export const DropZoneBar = styled.div<IDropZoneBar>(({ theme, isVisible }) => ({
    height: isVisible ? 3 : 0,
    width: '100%',
    transition: 'height 0.1s linear',
    backgroundColor: theme.colors.primary300,
}));
